export const hoursToRegister = [
  { name: "2 Hours", value: "2" },
  { name: "3 Hours", value: "3" },
  { name: "4 Hours", value: "4" },
  { name: "5 Hours", value: "5" },
  { name: "6 Hours", value: "6" },
];
export const priceCalculatorHours = [
  { name: "2 Hours", value: "2" },
  { name: "3 Hours", value: "3" },
  { name: "4 Hours", value: "4" },
  { name: "5 Hours", value: "5" },
  { name: "6 Hours", value: "6" },
  { name: "7 Hours", value: "7" },
  { name: "8 Hours", value: "8" },
  { name: "9 Hours", value: "9" },
  { name: "10 Hours", value: "10" },
  { name: "11 Hours", value: "11" },
  { name: "12 Hours", value: "12" },
];

export const guestsPerBartender = [
  { name: "25 Guests", value: "25" },
  { name: "50 Guests", value: "50" },
  { name: "75 Guests", value: "75" },
  { name: "100 Guests", value: "100" },
  { name: "125 Guests", value: "125" },
  { name: "150 Guests", value: "150" },
  { name: "175 Guests", value: "175" },
  { name: "200 Guests", value: "200" },
];
export const guestsPerBartenderDrop = [
  { label: "25", value: "25" },
  { label: "50", value: "50" },
  { label: "75", value: "75" },
  { label: "100", value: "100" },
  { label: "125", value: "125" },
  { label: "150", value: "150" },
  { label: "175", value: "175" },
  { label: "200", value: "200" },
];
// export const percentageTips = [
//   { label: "15.00 %", value: 15 },
//   { label: "18.00 %", value: 18 },
//   { label: "20.00 %", value: 20 }
// ];

export const TIPS_OPTIONS = [
  { name: "Yes", value: "true" },
  { name: "No", value: "false" },
];

export const SUPPLIES = [
  "Standard Cocktail Menu",
  "Bartender(s) plus their bar tools",
  "Garnishes",
  "Mixers",
  "Straws",
  "Napkins",
  "Cups",
  "Ice",
];

export const addOnsTypes = [
  { label: "Bartender", value: "bartender" },
  { label: "Fixed", value: "fixed" },
  { label: "Guests", value: "guests" },
  { label: "Hourly", value: "hourly" },
  { label: "Number of Cocktails", value: "NumOfCocktails" },
];

export const QuantityTypes = [
  { label: "qty", value: "qty" },
  { label: "lbs", value: "lbs" },
  { label: "oz", value: "oz" },
];

export const COCKTAILS_TYPES_DATA = [
  { name: "Tequila", value: "tequila" },
  { name: "Vodka", value: "vodka" },
  { name: "Whisky", value: "whisky" },
  { name: "Rum", value: "rum" },
  { name: "Rum Dark", value: "rum_dark" },
  { name: "Cognac", value: "cognac" },
  { name: "Gin", value: "gin" },
  { name: "Liqueur", value: "liqueur" },
  { name: "Mezcal", value: "mezcal" },
  { name: "Sparkling", value: "sparkling" },
  { name: "Mocktail", value: "mocktail" },
  { name: "Vermouth", value: "vermouth" },
  { name: "Other", value: "other" },
];
export const SPIRITS_BRAND_DATA = [
  { name: "Tequila", value: "tequila" },
  { name: "Vodka", value: "vodka" },
  { name: "Whisky", value: "whisky" },
  { name: "Rum", value: "rum" },
  { name: "Rum Dark", value: "rum_dark" },
  { name: "Cognac", value: "cognac" },
  { name: "Gin", value: "gin" },
  { name: "Liqueur", value: "liqueur" },
  { name: "Mocktail", value: "mocktail" },
  { name: "Mezcal", value: "mezcal" },
  { name: "Sparkling", value: "sparkling" }
];

export const ADDITIONAL_BEVERAGES_DATA = [
  { name: "Beer", value: "beer" },
  { name: "Seltzer", value: "seltzer" },
  // { name: "Beer Cocktail", value: "beer_cocktail" },
  { name: "Red Wine", value: "red_wine" },
  { name: "White Wine", value: "white_wine" },
  { name: "Sparkling Wine", value: "sparkling_wine" },
  { name: "Water", value: "water" },
]

export const cocktailBrandsData = [
  { label: "Brand 1", value: "Brand 1" },
  { label: "Brand 2", value: "Brand 2" },
  { label: "Brand 3", value: "Brand 3" },
];

export const isThisAlcoholData = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
export const alcoholQuantity = [
  { label: "0.75Oz", value: "0.75Oz" },
  { label: "1.00 Oz", value: "1.00 Oz" },
  { label: "2.00 Oz", value: "2.00 Oz" },
];

export const cocktailIngredientsData = [
  {
    ingredient: "Tequila",
    isAlcool: "Yes",
    quantity: "0.75 Oz",
  },
  {
    ingredient: "Lime Juice",
    isAlcool: "No",
    quantity: "0.75 Oz",
  },
  {
    ingredient: "Simple Syrup",
    isAlcool: "No",
    quantity: "0.75 Oz",
  },
  {
    ingredient: "Campari",
    isAlcool: "Yes",
    quantity: "0.75 Oz",
  },
  {
    ingredient: "Grapefruit Juice",
    isAlcool: "No",
    quantity: "0.75 Oz",
  },
];

export const PACKAGES_TYPES = [
  { name: "Standard", value: "standard" },
  // { name: 'Beer Wine', value: "beer_wine" },
];
export const timeZonesData = [
  { name: "Select", value: "Select" },
  { name: "Eastern Time Zone(ET)", value: "Eastern Time Zone(ET)" },
  { name: "Central Time Zone(CT)", value: "Central Time Zone(CT)" },
  { name: "Mountain Time Zone(MT)", value: "Mountain Time Zone(MT)" },
  { name: "Pacific Time Zone(PT)", value: "Pacific Time Zone(PT)" },
  { name: "Alaska Time Zone(AKT)", value: "Alaska Time Zone(AKT)" },
  {
    name: "Hawaii-Aleutian Time Zone(HAST)",
    value: "Hawaii-Aleutian Time Zone(HAST)",
  },
  { name: "America/Los_Angeles", value: "America/Los_Angeles" },
].map((timeZone) => ({ label: timeZone, value: timeZone }));

export const TIME_ZONES_LIST = [
  { name: "America/Adak", value: "America/Adak" },
  { name: "America/Anchorage", value: "America/Anchorage" },
  { name: "America/Anguilla", value: "America/Anguilla" },
  { name: "America/Antigua", value: "America/Antigua" },
  { name: "America/Araguaina", value: "America/Araguaina" },
  { name: "America/Argentina/Buenos_Aires", value: "America/Argentina/Buenos_Aires" },
  { name: "America/Argentina/Catamarca", value: "America/Argentina/Catamarca" },
  { name: "America/Argentina/ComodRivadavia", value: "America/Argentina/ComodRivadavia" },
  { name: "America/Argentina/Cordoba", value: "America/Argentina/Cordoba" },
  { name: "America/Argentina/Jujuy", value: "America/Argentina/Jujuy" },
  { name: "America/Argentina/La_Rioja", value: "America/Argentina/La_Rioja" },
  { name: "America/Argentina/Mendoza", value: "America/Argentina/Mendoza" },
  { name: "America/Argentina/Rio_Gallegos", value: "America/Argentina/Rio_Gallegos" },
  { name: "America/Argentina/Salta", value: "America/Argentina/Salta" },
  { name: "America/Argentina/San_Juan", value: "America/Argentina/San_Juan" },
  { name: "America/Argentina/San_Luis", value: "America/Argentina/San_Luis" },
  { name: "America/Argentina/Tucuman", value: "America/Argentina/Tucuman" },
  { name: "America/Argentina/Ushuaia", value: "America/Argentina/Ushuaia" },
  { name: "America/Aruba", value: "America/Aruba" },
  { name: "America/Asuncion", value: "America/Asuncion" },
  { name: "America/Atikokan", value: "America/Atikokan" },
  { name: "America/Atka", value: "America/Atka" },
  { name: "America/Bahia", value: "America/Bahia" },
  { name: "America/Bahia_Banderas", value: "America/Bahia_Banderas" },
  { name: "America/Barbados", value: "America/Barbados" },
  { name: "America/Belem", value: "America/Belem" },
  { name: "America/Belize", value: "America/Belize" },
  { name: "America/Blanc-Sablon", value: "America/Blanc-Sablon" },
  { name: "America/Boa_Vista", value: "America/Boa_Vista" },
  { name: "America/Bogota", value: "America/Bogota" },
  { name: "America/Boise", value: "America/Boise" },
  { name: "America/Buenos_Aires", value: "America/Buenos_Aires" },
  { name: "America/Cambridge_Bay", value: "America/Cambridge_Bay" },
  { name: "America/Campo_Grande", value: "America/Campo_Grande" },
  { name: "America/Cancun", value: "America/Cancun" },
  { name: "America/Caracas", value: "America/Caracas" },
  { name: "America/Catamarca", value: "America/Catamarca" },
  { name: "America/Cayenne", value: "America/Cayenne" },
  { name: "America/Cayman", value: "America/Cayman" },
  { name: "America/Chicago", value: "America/Chicago" },
  { name: "America/Chihuahua", value: "America/Chihuahua" },
  { name: "America/Ciudad_Juarez", value: "America/Ciudad_Juarez" },
  { name: "America/Coral_Harbour", value: "America/Coral_Harbour" },
  { name: "America/Cordoba", value: "America/Cordoba" },
  { name: "America/Costa_Rica", value: "America/Costa_Rica" },
  { name: "America/Coyhaique", value: "America/Coyhaique" },
  { name: "America/Creston", value: "America/Creston" },
  { name: "America/Cuiaba", value: "America/Cuiaba" },
  { name: "America/Curacao", value: "America/Curacao" },
  { name: "America/Danmarkshavn", value: "America/Danmarkshavn" },
  { name: "America/Dawson", value: "America/Dawson" },
  { name: "America/Dawson_Creek", value: "America/Dawson_Creek" },
  { name: "America/Denver", value: "America/Denver" },
  { name: "America/Detroit", value: "America/Detroit" },
  { name: "America/Dominica", value: "America/Dominica" },
  { name: "America/Edmonton", value: "America/Edmonton" },
  { name: "America/Eirunepe", value: "America/Eirunepe" },
  { name: "America/El_Salvador", value: "America/El_Salvador" },
  { name: "America/Ensenada", value: "America/Ensenada" },
  { name: "America/Fort_Nelson", value: "America/Fort_Nelson" },
  { name: "America/Fort_Wayne", value: "America/Fort_Wayne" },
  { name: "America/Fortaleza", value: "America/Fortaleza" },
  { name: "America/Glace_Bay", value: "America/Glace_Bay" },
  { name: "America/Godthab", value: "America/Godthab" },
  { name: "America/Goose_Bay", value: "America/Goose_Bay" },
  { name: "America/Grand_Turk", value: "America/Grand_Turk" },
  { name: "America/Grenada", value: "America/Grenada" },
  { name: "America/Guadeloupe", value: "America/Guadeloupe" },
  { name: "America/Guatemala", value: "America/Guatemala" },
  { name: "America/Guayaquil", value: "America/Guayaquil" },
  { name: "America/Guyana", value: "America/Guyana" },
  { name: "America/Halifax", value: "America/Halifax" },
  { name: "America/Havana", value: "America/Havana" },
  { name: "America/Hermosillo", value: "America/Hermosillo" },
  { name: "America/Indiana/Indianapolis", value: "America/Indiana/Indianapolis" },
  { name: "America/Indiana/Knox", value: "America/Indiana/Knox" },
  { name: "America/Indiana/Marengo", value: "America/Indiana/Marengo" },
  { name: "America/Indiana/Petersburg", value: "America/Indiana/Petersburg" },
  { name: "America/Indiana/Tell_City", value: "America/Indiana/Tell_City" },
  { name: "America/Indiana/Vevay", value: "America/Indiana/Vevay" },
  { name: "America/Indiana/Vincennes", value: "America/Indiana/Vincennes" },
  { name: "America/Indiana/Winamac", value: "America/Indiana/Winamac" },
  { name: "America/Indianapolis", value: "America/Indianapolis" },
  { name: "America/Inuvik", value: "America/Inuvik" },
  { name: "America/Iqaluit", value: "America/Iqaluit" },
  { name: "America/Jamaica", value: "America/Jamaica" },
  { name: "America/Jujuy", value: "America/Jujuy" },
  { name: "America/Juneau", value: "America/Juneau" },
  { name: "America/Kentucky/Louisville", value: "America/Kentucky/Louisville" },
  { name: "America/Kentucky/Monticello", value: "America/Kentucky/Monticello" },
  { name: "America/Knox_IN", value: "America/Knox_IN" },
  { name: "America/Kralendijk", value: "America/Kralendijk" },
  { name: "America/La_Paz", value: "America/La_Paz" },
  { name: "America/Lima", value: "America/Lima" },
  { name: "America/Los_Angeles", value: "America/Los_Angeles" },
  { name: "America/Louisville", value: "America/Louisville" },
  { name: "America/Lower_Princes", value: "America/Lower_Princes" },
  { name: "America/Maceio", value: "America/Maceio" },
  { name: "America/Managua", value: "America/Managua" },
  { name: "America/Manaus", value: "America/Manaus" },
  { name: "America/Marigot", value: "America/Marigot" },
  { name: "America/Martinique", value: "America/Martinique" },
  { name: "America/Matamoros", value: "America/Matamoros" },
  { name: "America/Mazatlan", value: "America/Mazatlan" },
  { name: "America/Mendoza", value: "America/Mendoza" },
  { name: "America/Menominee", value: "America/Menominee" },
  { name: "America/Merida", value: "America/Merida" },
  { name: "America/Metlakatla", value: "America/Metlakatla" },
  { name: "America/Mexico_City", value: "America/Mexico_City" },
  { name: "America/Miquelon", value: "America/Miquelon" },
  { name: "America/Moncton", value: "America/Moncton" },
  { name: "America/Monterrey", value: "America/Monterrey" },
  { name: "America/Montevideo", value: "America/Montevideo" },
  { name: "America/Montreal", value: "America/Montreal" },
  { name: "America/Montserrat", value: "America/Montserrat" },
  { name: "America/Nassau", value: "America/Nassau" },
  { name: "America/New_York", value: "America/New_York" },
  { name: "America/Nipigon", value: "America/Nipigon" },
  { name: "America/Nome", value: "America/Nome" },
  { name: "America/Noronha", value: "America/Noronha" },
  { name: "America/North_Dakota/Beulah", value: "America/North_Dakota/Beulah" },
  { name: "America/North_Dakota/Center", value: "America/North_Dakota/Center" },
  { name: "America/North_Dakota/New_Salem", value: "America/North_Dakota/New_Salem" },
  { name: "America/Nuuk", value: "America/Nuuk" },
  { name: "America/Ojinaga", value: "America/Ojinaga" },
  { name: "America/Panama", value: "America/Panama" },
  { name: "America/Pangnirtung", value: "America/Pangnirtung" },
  { name: "America/Paramaribo", value: "America/Paramaribo" },
  { name: "America/Phoenix", value: "America/Phoenix" },
  { name: "America/Port-au-Prince", value: "America/Port-au-Prince" },
  { name: "America/Port_of_Spain", value: "America/Port_of_Spain" },
  { name: "America/Porto_Acre", value: "America/Porto_Acre" },
  { name: "America/Porto_Velho", value: "America/Porto_Velho" },
  { name: "America/Puerto_Rico", value: "America/Puerto_Rico" },
  { name: "America/Punta_Arenas", value: "America/Punta_Arenas" },
  { name: "America/Rainy_River", value: "America/Rainy_River" },
  { name: "America/Rankin_Inlet", value: "America/Rankin_Inlet" },
  { name: "America/Recife", value: "America/Recife" },
  { name: "America/Regina", value: "America/Regina" },
  { name: "America/Resolute", value: "America/Resolute" },
  { name: "America/Rio_Branco", value: "America/Rio_Branco" },
  { name: "America/Rosario", value: "America/Rosario" },
  { name: "America/Santa_Isabel", value: "America/Santa_Isabel" },
  { name: "America/Santarem", value: "America/Santarem" },
  { name: "America/Santiago", value: "America/Santiago" },
  { name: "America/Santo_Domingo", value: "America/Santo_Domingo" },
  { name: "America/Sao_Paulo", value: "America/Sao_Paulo" },
  { name: "America/Scoresbysund", value: "America/Scoresbysund" },
  { name: "America/Shiprock", value: "America/Shiprock" },
  { name: "America/Sitka", value: "America/Sitka" },
  { name: "America/St_Barthelemy", value: "America/St_Barthelemy" },
  { name: "America/St_Johns", value: "America/St_Johns" },
  { name: "America/St_Kitts", value: "America/St_Kitts" },
  { name: "America/St_Lucia", value: "America/St_Lucia" },
  { name: "America/St_Thomas", value: "America/St_Thomas" },
  { name: "America/St_Vincent", value: "America/St_Vincent" },
  { name: "America/Swift_Current", value: "America/Swift_Current" },
  { name: "America/Tegucigalpa", value: "America/Tegucigalpa" },
  { name: "America/Thule", value: "America/Thule" },
  { name: "America/Thunder_Bay", value: "America/Thunder_Bay" },
  { name: "America/Tijuana", value: "America/Tijuana" },
  { name: "America/Toronto", value: "America/Toronto" },
  { name: "America/Tortola", value: "America/Tortola" },
  { name: "America/Vancouver", value: "America/Vancouver" },
  { name: "America/Virgin", value: "America/Virgin" },
  { name: "America/Whitehorse", value: "America/Whitehorse" },
  { name: "America/Winnipeg", value: "America/Winnipeg" },
  { name: "America/Yakutat", value: "America/Yakutat" },
  { name: "America/Yellowknife", value: "America/Yellowknife" },
];
